// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__4_4R3","text":"Checkbox_text__3fvJo"};